// Okienko ostrzezen (burza w okolicy stacji, burza geomagnetyczna...). Dane:
// /api/notices (blueprints/notices.py). Kazde ostrzezenie ma staly id --
// "Rozumiem" chowa je na dobre (w tej przegladarce), "Przypomnij za godzine"
// na 60 min. Gdy aplikacja jest zamknieta, te same ostrzezenia przychodza
// pushem (jesli wlaczone w przegladarce).
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Icon from './icons';
import { tx } from './i18n';

const API = process.env.REACT_APP_API_URL || '';
const STORE_KEY = 'hamlogger_notices_seen';
const POLL_MS = 5 * 60 * 1000;
const SNOOZE_MS = 60 * 60 * 1000;
const LEVEL_ORDER = { danger: 0, warning: 1, info: 2 };
const KIND_ICON = { storm: 'zap', geomagnetic: 'globe', wind: 'activity', ice: 'alert', flare: 'sun' };

function readSeen() {
  try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch { return {}; }
}
function writeSeen(seen) {
  // Sprzatanie: zostaw tylko ostatnie 50 wpisow
  const entries = Object.entries(seen).slice(-50);
  try { localStorage.setItem(STORE_KEY, JSON.stringify(Object.fromEntries(entries))); } catch {}
}
function isHidden(seen, id) {
  const v = seen[id];
  if (v === 'ok') return true;
  return typeof v === 'number' && v > Date.now();
}

export default function NoticeCenter() {
  const [notices, setNotices] = useState([]);
  const [seen, setSeen] = useState(readSeen);

  const load = useCallback(() => {
    axios.get(`${API}/api/notices`).then(r => setNotices(Array.isArray(r.data?.notices) ? r.data.notices : [])).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    const onVis = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onVis); };
  }, [load]);
  // Po uplywie drzemki okienko ma wrocic bez przeladowania strony
  useEffect(() => {
    const t = setInterval(() => setSeen(readSeen()), 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const visible = notices
    .filter(n => n && n.id && !isHidden(seen, n.id))
    .sort((a, b) => (LEVEL_ORDER[a.level] ?? 3) - (LEVEL_ORDER[b.level] ?? 3));
  if (!visible.length) return null;
  const n = visible[0];

  const mark = (value) => {
    const next = { ...readSeen(), [n.id]: value };
    writeSeen(next);
    setSeen(next);
  };

  return (
    <div className={`notice notice--${n.level || 'info'}`} role="alertdialog" aria-live="assertive" aria-labelledby="notice-title">
      <div className="notice__icon"><Icon name={KIND_ICON[n.kind] || 'alert'} size={22} /></div>
      <div className="notice__body">
        <div className="notice__head">
          <strong id="notice-title" className="notice__title">{n.title}</strong>
          {visible.length > 1 && <span className="notice__count">{tx('1 z {0}', [visible.length])}</span>}
        </div>
        {n.message && <p className="notice__msg">{n.message}</p>}
        {n.advice?.length > 0 && (
          <ul className="notice__advice">
            {n.advice.map((a, i) => <li key={i}>{a}</li>)}
          </ul>
        )}
        <div className="notice__foot">
          {n.source && <span className="notice__source">{tx('Źródło: {0}', [n.source])}</span>}
          <span className="notice__spacer" />
          <button type="button" className="btn btn--ghost btn--sm" onClick={() => mark(Date.now() + SNOOZE_MS)}>
            <Icon name="clock" size={15} /> {tx('Za godzinę')}
          </button>
          <button type="button" className="btn btn--primary btn--sm" onClick={() => mark('ok')}>
            <Icon name="check" size={15} /> {tx('Rozumiem')}
          </button>
        </div>
      </div>
    </div>
  );
}
